<template>
  <div class="float-btns">
    <template v-for="item in list">
      <div
        v-if="item.button_type == 3 || item.button_type == 4"
        class="float-btn"
        :key="item.id"
        @click="onButtonClick(item)"
      >
        <img class="float-btn_cover" :src="item.button_cover" />
        <div class="float-btn_name">{{ item.name }}</div>
      </div>
      <TooltipEx
        v-else
        class="float-btn"
        :key="item.id"
        placement="left"
        contentClass="float-btn_tooltip"
        :maxWidth="222"
        :delay="0"
      >
        <img class="float-btn_cover" :src="item.button_cover" />
        <div class="float-btn_name">{{ item.name }}</div>
        <template v-slot:content>
          <template v-if="item.button_type == 4 || item.button_type == 2">
            <div class="float-btn_title">{{ item.title }}</div>
            <div class="float-btn_subtitle">{{ item.sub_title }}</div>
            <img class="float-btn_image" :src="item.image" />
          </template>
          <div v-else v-html="item.content" class="rich-auto"></div>
        </template>
      </TooltipEx>
    </template>
    <div id="gotop">
      <div class="item" v-if="download">
        <i class="app-icon"></i>
        <p>下载App</p>
        <div class="box">
          <p class="b-title">扫码下载清北博雅App</p>
          <p class="l-title">用App上课，体验更好</p>
          <vue-qr :text="appUrl" :size="180" class="qrcode"></vue-qr>
        </div>
      </div>
    </div>
    <div class="float-btn" @click="goTop" v-if="goTopShow">
      <img
        class="float-btn_cover"
        src="@/assets/images/float-button/go-top@2x.png"
      />
      <div class="float-btn_name">回到顶部</div>
    </div>
  </div>
</template>
<script>
import TooltipEx from "@/components/TooltipEx.vue";
import VueQr from "vue-qr";
export default {
  name: "FloatButton",
  components: { TooltipEx, VueQr },
  data() {
    return {
      scrollTop: "",
      goTopShow: false,
      list: [],
      download: false,
    };
  },
  async created() {
    this.list = await this.$http.get("/api/app/hoverButton/index");
    let res = await this.$http.get(`/api/app/config/app_download_guide`);
    this.download = res.app_download_guide.is_show == 1;
  },
  computed: {
    appUrl() {
      return this.$store.state.otherSetting.h5_address + "download-app";
    },
  },
  methods: {
    handleScroll() {
      this.scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (this.scrollTop > 500) {
        this.goTopShow = true;
      } else {
        this.goTopShow = false;
      }
    },
    goTop() {
      let timer = null,
        that = this;
      cancelAnimationFrame(timer);
      timer = requestAnimationFrame(function fn() {
        if (that.scrollTop > 0) {
          that.scrollTop -= 50;
          document.body.scrollTop = document.documentElement.scrollTop =
            that.scrollTop;
          timer = requestAnimationFrame(fn);
        } else {
          cancelAnimationFrame(timer);
          that.goTopShow = false;
        }
      });
    },
    onButtonClick(item) {
      if (item.button_type == 3) {
        let a = document.createElement("a");
        a.href = item.content;
        a.target = item.open_type == 1 ? "_blank" : "";
        a.click();
      } else if (item.button_type == 4) {
        // let scriptId = "script_floatbutton_" + item.id;
        // let script = document.getElementById(scriptId);
        // if (script) {
        //   document.body.removeChild(script);
        // }
        // script = document.createElement("script");
        // script.id = scriptId;
        // document.body.append(script);
        // script.innerHTML = item.content;
        this.kefu()
      }
    },
    kefu(){
      window.canCustomerServer.getCustomeServer();            
    }
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>
<style lang="scss" scoped>
.float-btns {
  position: fixed;
  bottom: 40%;
  right: 10px;
  z-index: 999;
}
.float-btn {
  width: 88px;
  height: 88px;
  // background: rgba($color: #000000, $alpha: 0.35);
    background: #fff;
    box-shadow: 5px 5px 10px rgba(0,0,0,0.1);
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;
  position: relative;
  cursor: pointer;

  &:hover {
    // background: rgba($color: #000000, $alpha: 0.5);
  }

  &:last-child {
    margin-bottom: 0;
  }
}
.float-btn_cover {
  width: 32px;
  height: 32px;
}
.float-btn_name {
  height: 18px;
  font-size: 12px;
  color: #4f5666;
  line-height: 28px;
}
.float-btn_title {
  font-size: 18px;
  font-weight: 500;
  color: #333333;
  line-height: 24px;
  margin-bottom: 8px;
  text-align: center;
}
.float-btn_subtitle {
  font-size: 14px;
  color: #666666;
  line-height: 20px;
  text-align: center;
  margin-bottom: 22px;
}
.float-btn_image {
  width: 146px;
  height: 146px;
  border: 1px solid #e0e0e0;
  display: block;
  margin: 0 auto;
  margin-bottom: 5px;
}
</style>
<style lang="scss">
.float-btn_tooltip {
  box-shadow: none !important;
  border: 1px solid #eaeaea;
  padding: 0 !important;
  width: 222px;

  .tooltipex-content {
    padding: 24px 22px;
  }

  .tooltipex-arrow::before {
    content: "";
    position: absolute;
    width: 0;
    height: 0;
    border: 8px solid transparent;
    top: -8px;
    left: -8px;
    border-left-color: white;
    z-index: 1;
  }

  .tooltipex-arrow::after {
    content: "";
    position: absolute;
    width: 0;
    height: 0;
    border: 9px solid transparent;
    top: -9px;
    left: -8px;
    border-left-color: #eaeaea;
    z-index: 0;
  }
}
#gotop {
  .item {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    width: 88px;
    height: 88px;
    margin-bottom: 10px;
    // background-color: rgba(0, 0, 0, 0.35);
        background-color: #fff;
    box-sizing: border-box;
    border-radius: 10px;
    cursor: pointer;
    > p {
      margin-top: 4px;
      font-size: 12px;
      color: #fff;
      line-height: 14px;
    }
    .app-icon {
      display: block;
      width: 24px;
      height: 24px;
      background: url("~@/assets/images/icon_gotop_app.png") center no-repeat;
      background-size: 34px 34px;
    }
    .top-icon {
      display: block;
      width: 34px;
      height: 34px;
      background: url("~@/assets/images/icon_gotop_top.png") center no-repeat;
      background-size: 34px 34px;
    }
    .box {
      display: none;
      position: absolute;
      top: 50%;
      right: 100px;
      width: 218px;
      padding-bottom: 6px;
      background-color: #fff;
      border: 1px solid #eaeaea;
      border-radius: 4px;
      transform: translateY(-50%);
      box-sizing: border-box;
      .b-title {
        margin: 28px 0 14px;
        text-align: center;
        font-size: 18px;
        font-family: PingFangSC-Medium;
        font-weight: 500;
        color: #333333;
        line-height: 18px;
      }
      .l-title {
        margin-bottom: 3px;
        text-align: center;
        font-size: 14px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: #999999;
        line-height: 14px;
      }
      div {
        padding: 0;
        width: 218px;
        background-color: #fff;
        box-sizing: border-box;
        text-align: center;
        img {
          display: block;
          width: 150px;
          margin-left: 34px;
          height: 150px;
        }
        p {
          white-space: nowrap;
          font-size: 18px;
          color: #333;
        }
      }
      &::before {
        content: "";
        position: absolute;
        top: 50%;
        right: -9px;
        display: none;
        width: 0;
        height: 0;
        border-color: transparent;
        border-style: solid;
        border-width: 10px;
        border-right-width: 0;
        border-left-color: #fff;
        transform: translateY(-50%);
        z-index: 10;
      }
      &::after {
        content: "";
        position: absolute;
        top: 50%;
        right: -10px;
        display: none;
        width: 0;
        height: 0;
        border-color: transparent;
        border-style: solid;
        border-width: 10px;
        border-right-width: 0;
        border-left-color: rgba(234, 234, 234, 1);
        transform: translateY(-50%);
      }
    }
    &:hover {
      background-color: rgba(0, 0, 0, 0.5);
      .box {
        display: block;
        &::after,
        &::before {
          display: block;
        }
      }
    }
  }
}
</style>
